import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      d: "m12.5 1.5-11 11m0-11 11 11"
    }, null, -1)
  ]));
}
const Close = { render };
export {
  Close as default,
  render
};
//# sourceMappingURL=Close.svg.js.map
